import type { GetSuggestionDetailResponse } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';
import type { AssignmentLine } from 'src/api/rpc/hooks/procurement/useReplenishmentSuggestions';

/** Minimal assignment-line shape for bulk override planning from modal detail. */
export function assignmentLineFromSuggestionDetail(
  suggestion: GetSuggestionDetailResponse,
): AssignmentLine {
  return {
    suggestionId: suggestion.suggestionId,
    productV3Key: suggestion.productV3Key,
    productSku: suggestion.productSku ?? suggestion.productV3Key,
    destinationWarehouseId: suggestion.destinationWarehouseId,
    neededQuantity: suggestion.neededQuantity,
    status: suggestion.status,
  } as AssignmentLine;
}
